<template>
    <component
        :is="component"
        v-bind="componentAttrs"
        v-on="componentEvents"
    />
</template>

<script>
import AuthStateMixin from '@/mixins/AuthStateMixin'
import AuthHelper from '@/pages/auth/helpers/AuthHelper'
import LoginMain from '@/pages/auth/login/variants/Main'
import LoginCompany from '@/pages/auth/login/variants/Company'

import {Utils} from '@framework'

export default {
    name: 'login',
    mixins: [AuthStateMixin, ...AuthHelper.loginMixins()],
    components: {
        [LoginMain.name]: LoginMain,
        [LoginCompany.name]: LoginCompany
    },
    data() {
        return {
            component: 'div',
            componentAttrs: {},
            componentEvents: {}
        }
    },
    created() {

        if ( parseInt(Utils.getQueryStringParam.bind(this)('force')) !== 1 && this.$root.authInfo.users.length > 0 ) {
            this.$router.push({
                path: `/choose-an-account`
            })
            return
        }

        //////////////////////

        let components = {
            loginCompany: 'login-company',
            login: 'login-main'
        }

        let component = components['login']
        if( _appConfig.client.client_id ) {
            component = components['loginCompany']
        }

        this.component = component
        this.componentAttrs = {}
        this.componentEvents = {
            'choose-account': () => {
                this.$router.push({
                    path: 'choose-an-account'
                })
            }
        }

        if( false !== AuthHelper.getLoginComponent() )
        {
            let loginComponent = AuthHelper.getLoginComponent()

            if( loginComponent.component ) {
                this.component = loginComponent.component
            }

            if( loginComponent.componentAttrs ) {
                this.componentAttrs = loginComponent.componentAttrs
            }

            if( loginComponent.componentEvents ) {
                this.componentEvents = loginComponent.componentEvents
            }
        }
    }
}
</script>
